import { createLoadingStatusActionGroupWithResponse } from '~/shared/helpers/loading-status-helper';
import { InvestmentOrderAuthorizationResponse, InvestmentOrderRequest, OrderSideEnum, ValidationViolation } from '@qvs/core';
import { createAction, props } from '@ngrx/store';

const prefix = '[New Investment Order]';

export const updateInvestmentOrderRequest = createAction(
  `${prefix} Update investmentOrder request and validation violations`,
  props<{ investmentOrderRequest: InvestmentOrderRequest; violations?: ValidationViolation[] }>()
);

export const {
  load: createInvestmentOrder,
  success: createInvestmentOrderSuccess,
  failure: createInvestmentOrderFailure
} = createLoadingStatusActionGroupWithResponse<{ orderId: number }>(prefix, 'createInvestmentOrder');

export const {
  load: authorizeInvestmentOrder,
  success: authorizeInvestmentOrderSuccess,
  failure: authorizeInvestmentOrderFailure
} = createLoadingStatusActionGroupWithResponse<{ authorizationCode: number }>(prefix, 'authorizeInvestmentOrder');

export const cancelAuthorization = createAction(`${prefix} cancel investmentOrder authorization`);

export const {
  load: confirmInvestmentOrder,
  success: confirmInvestmentOrderSuccess,
  failure: confirmInvestmentOrderFailure
} = createLoadingStatusActionGroupWithResponse<{
  investOrderAuthorizationResponse: InvestmentOrderAuthorizationResponse;
}>(prefix, 'confirmInvestmentOrder');

export const setOrderSide = createAction(
  `${prefix} set order side for investmentOrderRequest`,
  props<{ orderSide: OrderSideEnum }>()
);

export const setAccountId = createAction(`${prefix} set accountId for investmentOrderRequest`, props<{ accountId: string }>());

export const setAllowAllPortfolios = createAction(
  `${prefix} set allowAllPortfolios for investmentOrderRequest`,
  props<{ allowAllPortfolios: boolean }>()
);

export const resetNewInvestmentOrderForm = createAction(`${prefix} reset new investment order form`);
